module.exports = __webpack_public_path__ + "static/404-ad24ff44ea9e4f1eefc80b0d7dedb5c5.gif";